import React from "react";

import { GenericObject } from "src/api/flowTypes";
import { ErrorSection } from "src/base-components/MultipleErrorCallout";
import { TableComp as Table } from "src/base-components/Table";
import { getColumns } from "src/dataTable/TableUtils";
import { Callout } from "src/design-system/Callout";

type Props = {
  errorSections: ErrorSection[];
  failingInput?: GenericObject;
  action?: {
    text: string;
    onClick: () => void;
  };
};

// Errors found here from nodes
export const NodeErrorCallout: React.FC<Props> = ({
  errorSections,
  failingInput,
  action,
}) => {
  return (
    <>
      <Callout action={action} variant="error">
        <div
          /*min-w-0 necessary because of the parent flex box */
          className="min-w-0 whitespace-pre-wrap break-words"
        >
          <Callout.BlobContent items={errorSections} />
        </div>
      </Callout>

      {failingInput && (
        <div className="mt-6">
          <div className="mb-4 font-inter-semibold-13px text-gray-800">
            Failing Node input:
          </div>
          <Table
            columns={getColumns([failingInput], "topLeft")}
            data={[failingInput]}
            frameClassName="px-4 border border-gray-200 rounded-lg"
            rowClassName="border-t"
          />
        </div>
      )}
    </>
  );
};
